import './style.scss';

import React, { useContext } from 'react';
import { CreateEvaluationKnowledgeContext } from '../../../pctContexts/contextEvaluationKnowledge';
import { Button, Text } from 'pctComponents/atoms';
import { TbListCheck } from 'react-icons/tb';
import { FaRegStar } from 'react-icons/fa';
import { LuTimer } from 'react-icons/lu';
import { GrLinkNext } from 'react-icons/gr';

import useTimeMoment from '../../../pctHooks/useTimeMoment';

const EvaluationKnowledgeIntroduction = () => {
    const { contextCurrentEvaluation, contextGoToEvaluationScreen, setEvaluationCurrentIndex } = useContext(
        CreateEvaluationKnowledgeContext,
    );

    const timeMoment = useTimeMoment({
        temp: contextCurrentEvaluation.parameters.timeLimit,
        format: 'hh __ mm __',
        dur: 's',
    });

    const evaluationParameters = contextCurrentEvaluation.parameters || {};
    const currentAttempt = contextCurrentEvaluation.attempts || 1;
    const maxTries = evaluationParameters.maxTries || 1;
    const questionAmount = evaluationParameters.questionAmount || 0;
    const lockNavigation = String(evaluationParameters.lockNavigation) === '1';
    const saveHighestScore = String(evaluationParameters.saveHighestScore) === '1';

    return (
        <div
            className={`ptcQuestionnaireIntroduction ${
                !contextCurrentEvaluation.description ? 'questionnaireIntroductionNoDescription' : ''
            }`}
        >
            <div className="questionnaireIntroductionBase">
                <div className="introTitleContent">
                    <Text component={'h1'} text={contextCurrentEvaluation.title} className="tittle" />
                    <Text
                        component={'p'}
                        text="Uma avaliação de conhecimento tem como objetivo validar sua compreensão sobre os conteúdos do curso."
                        className="introDescription"
                    />
                </div>

                <div className="evaluationInfos">
                    <Text
                        component={'h2'}
                        className="attentionTitle"
                        text={`Atenção: você tem <strong>${maxTries} ${maxTries == 1 ? 'tentativa' : 'tentativas'}</strong><br />para realizar esta avaliação.`}
                    />
                   { maxTries != 1 &&(<Text
                        component={'p'}
                        text="Se não atingir a nota desejada na primeira vez, você poderá revisar o conteúdo e tentar novamente para melhorar seu desempenho. Boa sorte!"
                        className="attentionDescription"
                    />)}

                    <div className="evaluationInfosList">
                        {saveHighestScore &&(
                            <div className="listItem">
                                <FaRegStar />
                                <Text
                                    component={'p'}
                                    text="Será considerada a melhor nota entre todas as tentativas."
                                />
                            </div>
                        )}
                            {contextCurrentEvaluation.parameters.timeLimit !== '0' && (
                                <div className="listItem">
                                    <LuTimer />
                                    <Text component={'p'} text={`Tempo de execução: <strong>${timeMoment}</strong>`} />
                                </div>
                            )}
                        {lockNavigation && (
                            <div className="listItem">
                                <GrLinkNext className="icoNext" />
                                <Text
                                    component={'p'}
                                    text="Só será possível avançar as questões ao responder uma a uma."
                                />
                            </div>
                        )}
                        <div className="listItem">
                            <TbListCheck />
                            <Text component={'p'} text={`Total de questões: ${questionAmount}`} />
                        </div>
                    </div>
                </div>

                <div className="actionContent">
                    <div className="btnsIntro">
                        <Button
                            className={'button05'}
                            text={maxTries != 1 ?(`Iniciar ${currentAttempt} de ${maxTries}`):(`Iniciar Avaliação`)}
                            callEvent={() => {
                                setEvaluationCurrentIndex(0);
                                contextGoToEvaluationScreen('PLAYER');
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EvaluationKnowledgeIntroduction;
